  import React, { useState, useEffect } from "react";
  import DataTable from "react-data-table-component";
  import axios from "axios";
  import moment from "moment";
  import $ from "jquery";
  import "daterangepicker/daterangepicker.css";
  import "daterangepicker";
  import { CSVLink } from "react-csv";

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const OtherPaymentReport = () => {
    const today = moment().format("YYYY-MM-DD");
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [payments, setPayments] = useState([]);
    const [search, setSearch] = useState("");
    const [filteredPayments, setFilteredPayments] = useState([]);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [selectedServiceType, setSelectedServiceType] = useState("all");

    useEffect(() => {
      fetchPayments();
      fetchServiceTypes();
    }, []);

    useEffect(() => {
      $("#dateRangePicker").daterangepicker(
        {
          startDate: moment(startDate),
          endDate: moment(endDate),
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
          },
        },
        (start, end) => {
          const newStart = start.format("YYYY-MM-DD");
          const newEnd = end.format("YYYY-MM-DD");
          setStartDate(newStart);
          setEndDate(newEnd);
          applyFilters(search, start, end);
          if (newStart === newEnd) {
            $("#dateRangePicker").html(start.format("MMMM D, YYYY"));
          } else {
            $("#dateRangePicker").html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);
          }
        }
      );

      $("#dateRangePicker").html(moment(today).format("MMMM D, YYYY"));
    }, []);

    useEffect(() => {
      applyFilters(search, moment(startDate), moment(endDate));
    }, [payments, search, startDate, endDate]);

    const fetchPayments = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/other_payment_service`);
        setPayments(response.data);
        setFilteredPayments(response.data);
      } catch (error) {
        console.error("Error fetching payments", error);
      }
    };

    const fetchServiceTypes = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/get_other_service_mode`);
        setServiceTypes(response.data);
      } catch (error) {
        console.error("Error fetching service types", error);
      }
    };

    const handleServiceTypeChange = (e) => {
      const type = e.target.value;
      setSelectedServiceType(type);
      applyFilters(search, moment(startDate), moment(endDate), type);
    };

    const applyFilters = (searchText, start, end, serviceType = selectedServiceType) => {
      const filteredData = payments
        .filter((payment) => {
          const txnDate = moment(payment.TXN_DATE);
          const isWithinRange = txnDate.isBetween(start, end, undefined, "[]");
          const matchesSearch =
            payment.name.toLowerCase().includes(searchText.toLowerCase()) ||
            payment.mobile.includes(searchText) ||
            payment.inv_no.includes(searchText);
          const matchesServiceType = 
            serviceType === "all" || 
            payment.type.toString() === serviceType;

          return isWithinRange && matchesSearch && matchesServiceType;
        })
        .map((payment, index) => ({ ...payment, sNo: index + 1 }));
      setFilteredPayments(filteredData);
    };

    const handleSearch = (e) => {
      setSearch(e.target.value);
      applyFilters(e.target.value, moment(startDate), moment(endDate));
    };

    const handleViewProof = (proofUrl) => {
      if (proofUrl) {
        window.open(proofUrl, "_blank");
      } else {
        alert("Payment proof not available.");
      }
    };

    const handleViewInvoice = (invoiceUrl) => {
      if (invoiceUrl) {
        window.open(invoiceUrl, "_blank");
      } else {
        alert("Invoice PDF not available.");
      }
    };

    const csvHeaders = [
      { label: "S.No", key: "sNo" },
      { label: "Invoice no", key: "inv_no" },
      { label: "Name", key: "name" },
      { label: "Payment Mode", key: "payment_mode" },
      { label: "Transaction No", key: "TXN_ID" },
      { label: "Transaction Date", key: "TXN_DATE_new" },
      { label: "Plan Amount (₹)", key: "actual_amount" },
      { label: "CGST (₹)", key: "cgst" },
      { label: "SGST (₹)", key: "sgst" },
      { label: "Total Amount (₹)", key: "TXN_AMOUNT" },
      { label: "Added By", key: "cby" },
      { label: "Payment Proof URL", key: "payment_proof" },
      { label: "Invoice URL", key: "invoice_path" }
    ];

    const prepareCSVData = () => {
      return filteredPayments.map(payment => {
        const total = parseFloat(payment.TXN_AMOUNT) || 0;
        const gstPercent = parseFloat(payment.gst_percent) || 0;
        const planAmount = total / (1 + gstPercent / 100);
        const gst = total - planAmount;

        return {
          ...payment,
          sNo: payment.sNo,
          inv_no: `\t${payment.inv_no}`,  // 👈 Tab prefix to keep "00003" as-is
          TXN_DATE_new: `"${moment(payment.TXN_DATE).format("DD-MM-YYYY")}"`,
          cgst: (gst / 2).toFixed(2),
          sgst: (gst / 2).toFixed(2),
          TXN_AMOUNT: `₹${payment.TXN_AMOUNT}`,
          actual_amount: `₹${payment.actual_amount}`
        };
      });
    };
    

    const columns = [
      { name: "S.No", selector: (row) => row.sNo, sortable: false, width: "70px" },
      // { name: "Invoice.No", selector: (row) => row.inv_no, sortable: false, width: "70px" },

      { name: "Name", selector: (row) => row.name, sortable: true },
      { name: "Mobile No", selector: (row) => row.mobile, sortable: true },
      { name: "Payment Mode", selector: (row) => row.payment_mode, sortable: true },
      // { name: "Invoice Prefix", selector: (row) => row.inv_prefix, sortable: true, width: "150px" },
      { name: "Transaction No", selector: (row) => row.TXN_ID, sortable: true },
      { name: "Transaction Date", selector: (row) => row.TXN_DATE, sortable: true },
      { name: 'Status', selector: (row) => row.TXN_STATUS},
      { name: "Total Amount", selector: (row) => `₹${row.TXN_AMOUNT}`, sortable: true },
      // { name: "Plan Amount", selector: (row) => `₹${row.actual_amount}`, sortable: true },
      // {
      //   name: "CGST",
      //   selector: (row) => {
      //     const total = parseFloat(row.TXN_AMOUNT) || 0;
      //     const gstPercent = parseFloat(row.gst_percent) || 0;
      //     const planAmount = total / (1 + gstPercent / 100);
      //     const gst = total - planAmount;
      //     return `₹${(gst / 2).toFixed(2)}`;
      //   },
      //   sortable: true
      // },
      // {
      //   name: "SGST",
      //   selector: (row) => {
      //     const total = parseFloat(row.TXN_AMOUNT) || 0;
      //     const gstPercent = parseFloat(row.gst_percent) || 0;
      //     const planAmount = total / (1 + gstPercent / 100);
      //     const gst = total - planAmount;
      //     return `₹${(gst / 2).toFixed(2)}`;
      //   },
      //   sortable: true
      // },
      { name: "Added By", selector: (row) => row.cby },
      { name: "Remarks", selector: (row) => row.payment_remark,width: "200px"},

      {
        name: "PAYMENT PROOF",
        cell: (row) => (
          <button
            onClick={() => handleViewProof(row.payment_proof)}
            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
          >
            View Proof
          </button>
        ),
      },
      {
        name: "INVOICE",
        cell: (row) => (
          <button
            onClick={() => handleViewInvoice(row.invoice_path)}
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
          >
            View Invoice
          </button>
        ),
      },
    ];

    return (
      <div className="bg-gray-100 p-6">
        <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-lg p-6">
          <h1 className="text-2xl font-semibold mb-4 text-blue-700 text-center">
            Other Payment Report
          </h1>
          
          <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
            <div className="flex items-center gap-3">
              <label className="font-bold">Filter by Date:</label>
              <div
                id="dateRangePicker"
                className="inline-block p-2 rounded cursor-pointer border border-gray-300"
              >
                {startDate === endDate
                  ? moment(startDate).format("MMMM D, YYYY")
                  : `${moment(startDate).format("MMMM D, YYYY")} - ${moment(endDate).format("MMMM D, YYYY")}`}
              </div>
              
              <select
                value={selectedServiceType}
                onChange={handleServiceTypeChange}
                className="border border-gray-300 rounded-md p-2"
              >
                <option value="all">All Service Types</option>
                {serviceTypes.map((service) => (
                  <option key={service.id} value={service.id}>
                    {service.service}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="flex items-center gap-3">
              <input
                type="text"
                placeholder="Search by name, mobile or invoice..."
                value={search}
                onChange={handleSearch}
                className="border border-gray-300 rounded-md p-2"
              />
              
              <CSVLink  
                data={prepareCSVData()}
                headers={csvHeaders}
                filename={`OtherPaymentReport_${moment().format('YYYYMMDD_HHmmss')}.csv`}
                className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
                enclosingCharacter={`"`}
              >
                Export to Excel
              </CSVLink>
            </div>
          </div>
          
          <DataTable
            columns={columns}
            data={filteredPayments}
            pagination
            highlightOnHover
            striped
            persistTableHead
            responsive
          />
        </div>
      </div>
    );
  };

  export default OtherPaymentReport;